import { toast } from 'react-toastify';
import CustomToast, {
  type CustomToastAction,
  type ToastType,
} from '@/shared/components/ui/CustomToast/CustomToast';

interface ShowToastProps {
  type: ToastType;
  title: string;
  message: string;
  actions?: CustomToastAction[];
}

export function showToast({ type, title, message, actions }: ShowToastProps) {
  // Actions need to stay on screen until clicked, not auto-dismiss; such a toast gets a close button.
  const persistent = Boolean(actions && actions.length > 0);
  toast(
    ({ closeToast }) => (
      <CustomToast
        type={type}
        title={title}
        message={message}
        actions={actions}
        onClose={persistent ? closeToast : undefined}
      />
    ),
    {
      icon: false,
      closeButton: false,
      hideProgressBar: true,
      className: '!bg-transparent !shadow-none !p-0',
      autoClose: persistent ? false : undefined,
      // bodyClassName: '!p-0',
    }
  );
}
